module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.0.0.box.226.110.1220.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.27.0.0.box.226.110.872.94.q.80"
    }
  }, [_vm._v("CANDY BAR CAKE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.27.0.1.box.228.215.1218.107.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Candy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ingredients")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("similar ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("famous ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("candy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bar ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.27.1.0.box.228.505.1069.366.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0029.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.6.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.2.0.box.232.974.1262.796.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.2.0.box.232.974.1260.272.q.60"
    }
  }, [_vm._v("Cream sugar and margarine together. Beat eggs into the mixture one at a time. Sift the two flours together, add alternately with the milk. Stir the vanilla in the mixture and pour batter into 3 greased and floured 8-inch pans. Bake at 350° for 30 minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.2.1.box.232.1322.1262.448.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.7.0.0"
    }
  }), _vm._v("It is important to prepare the filling while the cake is baking. The cake should be stacked while it is still warm and the filling is still hot. The heat holds the layers together. Put sugar and milk in a saucepan and bring to a boil. Add coconut and marshmallows. Stir and cook for 5 minutes. Add vanilla. Spread between cake layers as you remove layers from the pans. Do not put any on the top layer; it will be frosted.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.27.3.0.box.233.1881.892.158.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.10.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0030.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.10.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.4.0.box.227.2144.1267.167.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "id": "para.27.4.0.box.227.2144.1267.167.q.60"
    }
  }, [_vm._v("Combine ingredients and, stirring constantly, bring to a boil. Boil hard for 2 minutes. Remove from heat and beat until thick enough to spread. Frost cake. Serves 16.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cff2982","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0031.vue
// module id = 78
// module chunks = 0